var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#99A6B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#download-with-background_svg__clip0_2430_325)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.963 7c.595 0 1.116.519 1.116 1.111v9.407c0 .593-.52 1.112-1.116 1.112-.596 0-1.116-.519-1.116-1.111V8.11c0-.592.52-1.111 1.116-1.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.423 13.222c.372-.37.893-.37 1.265 0l2.68 2.667c.371.37.893.37 1.265 0l2.679-2.667c.372-.37.893-.37 1.265 0l.074.074c.372.37.372.89 0 1.26l-4.018 4c-.372.37-.893.37-1.266 0l-4.018-4c-.372-.37-.372-.89 0-1.26l.074-.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.958 23H8.042A1.015 1.015 0 017 21.963v-2.74c0-.593.447-1.038 1.042-1.038s1.042.445 1.042 1.037v1.704h11.832v-1.704c0-.592.447-1.037 1.042-1.037.596 0 1.042.445 1.042 1.037v2.741c0 .518-.52 1.037-1.042 1.037z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "download-with-background_svg__clip0_2430_325"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 7)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgDownloadWithBackground;